const cursos = [
  { codigo: 1001, nome: "Agente Comunitário de Saúde" },
  { codigo: 1002, nome: "Análises clínicas" },
  { codigo: 1004, nome: "Citopatologia" },
  { codigo: 1005, nome: "Controle Ambiental" },
  { codigo: 1029, nome: "Cuidados de Idosos" },
  { codigo: 1006, nome: "Enfermagem" },
  { codigo: 1007, nome: "Equipamentos Biomédicos" },
  { codigo: 1008, nome: "Estética" },
  { codigo: 1009, nome: "Farmácia" },
  { codigo: 1010, nome: "Gerência de Saúde" },
  { codigo: 1011, nome: "Hemoterapia" },
  { codigo: 1013, nome: "Imagem Pessoal" },
  { codigo: 1014, nome: "Imobilizações Ortopédicas" },
  { codigo: 1015, nome: "Massoterapia" },
  { codigo: 1016, nome: "Meio Ambiente" },
  { codigo: 1017, nome: "Meteorologia" },
  { codigo: 1030, nome: "Necropsia" },
  { codigo: 1018, nome: "Nutrição e Dietética" },
  { codigo: 1019, nome: "Óptica" },
  { codigo: 1020, nome: "Órteses e Próteses" },
  { codigo: 1021, nome: "Podologia" },
  { codigo: 1022, nome: "Prótese Dentária" },
  { codigo: 1023, nome: "Radiologia" },
  { codigo: 1024, nome: "Dependência química" },
  { codigo: 1025, nome: "Reciclagem" },
  { codigo: 1026, nome: "Registros e Informações em Saúde" },
  { codigo: 1012, nome: "Saúde Bucal" },
  { codigo: 1028, nome: "Vigilância em Saúde" },
  { codigo: 1031, nome: "Optometria" },
  { codigo: 1032, nome: "Terapias Holísticas" },
  { codigo: 1033, nome: "Veterinária" },
  { codigo: 1999, nome: "Outros - Eixo Ambiente e Saúde" },
  { codigo: 2029, nome: "Alimentação Escolar" },
  { codigo: 2030, nome: "Biblioteconomia" },
  { codigo: 2031, nome: "Infraestrutura escolar" },
  { codigo: 2039, nome: "Laboratório de Ciências da Natureza" },
  { codigo: 2035, nome: "Brinquedoteca" },
  { codigo: 2032, nome: "Multimeios Didáticos" },
  { codigo: 2033, nome: "Desenvolvimento Comunitário" },
  { codigo: 2036, nome: "Produção de materiais didáticos bilíngues em Libras/Língua Portuguesa" },
  { codigo: 2034, nome: "Secretaria Escolar" },
  { codigo: 2037, nome: "Tradução e Interpretação de Libras" },
  { codigo: 2038, nome: "Treinamento e Instrução de Cães-Guias" },
  { codigo: 2040, nome: "Arquivo" },
  { codigo: 2999, nome: "Outros - Eixo Desenvolvimento educacional e social" },
  { codigo: 3036, nome: "Automação Industrial" },
  { codigo: 3037, nome: "Eletroeletrônica" },
  { codigo: 3038, nome: "Eletromecânica" },
  { codigo: 3039, nome: "Eletrônica" },
  { codigo: 3040, nome: "Eletrotécnica" },
  { codigo: 3041, nome: "Manutenção Automotiva" },
  { codigo: 3050, nome: "Manutenção Aeronáutica em Aviônicos" },
  { codigo: 3051, nome: "Manutenção Aeronáutica em Célula" },
  { codigo: 3052, nome: "Manutenção Aeronáutica em Grupo Motopropulsor" },
  { codigo: 3060, nome: "Manutenção de Máquinas Industriais" },
  { codigo: 3042, nome: "Manutenção de Máquinas Navais" },
  { codigo: 3053, nome: "Manutenção de Máquinas Pesadas" },
  { codigo: 3054, nome: "Manutenção de Sistemas Metroferroviários" },
  { codigo: 3043, nome: "Mecânica" },
  { codigo: 3055, nome: "Mecânica de Precisão" },
  { codigo: 3044, nome: "Mecatrônica" },
  { codigo: 3045, nome: "Metalurgia" },
  { codigo: 3056, nome: "Metrologia" },
  { codigo: 3048, nome: "Refrigeração e Climatização" },
  { codigo: 3049, nome: "Sistemas a Gás" },
  { codigo: 3058, nome: "Sistemas de Energia Renovável" },
  { codigo: 3059, nome: "Soldagem" },
  { codigo: 3061, nome: "Ferramentaria" },
  { codigo: 3062, nome: "Fundição" },
  { codigo: 3063, nome: "Instrumentação Industrial" },
  { codigo: 3064, nome: "Fabricação Mecânica" },
  { codigo: 3999, nome: "Outros - Eixo Controle e Processos Industriais" },
  { codigo: 4050, nome: "Administração" },
  { codigo: 4051, nome: "Comércio" },
  { codigo: 4052, nome: "Comércio Exterior" },
  { codigo: 4053, nome: "Contabilidade" },
  { codigo: 4054, nome: "Cooperativismo" },
  { codigo: 4055, nome: "Finanças" },
  { codigo: 4056, nome: "Logística" },
  { codigo: 4057, nome: "Marketing" },
  { codigo: 4058, nome: "Qualidade" },
  { codigo: 4059, nome: "Recursos Humanos" },
  { codigo: 4060, nome: "Secretariado" },
  { codigo: 4061, nome: "Seguros" },
  { codigo: 4062, nome: "Condomínio" },
  { codigo: 4066, nome: "Serviços Jurídicos" },
  { codigo: 4063, nome: "Serviços Públicos" },
  { codigo: 4064, nome: "Transações Imobiliárias" },
  { codigo: 4065, nome: "Vendas" },
  { codigo: 4999, nome: "Outros - Eixo Gestão e Negócios" },
  { codigo: 5066, nome: "Agenciamento de Viagem" },
  { codigo: 5067, nome: "Gastronomia" },
  { codigo: 5068, nome: "Eventos" },
  { codigo: 5069, nome: "Guia de Turismo" },
  { codigo: 5070, nome: "Hospedagem" },
  { codigo: 5071, nome: "Lazer" },
  { codigo: 5072, nome: "Servicos de Restaurante e Bar" },
  { codigo: 5999, nome: "Outros - Eixo Turismo, hospitalidade e Lazer" },
  { codigo: 6081, nome: "Computação Gráfica" },
  { codigo: 6082, nome: "Desenvolvimento de Sistemas" },
  { codigo: 6073, nome: "Informática" },
  { codigo: 6074, nome: "Informática para Internet" },
  { codigo: 6075, nome: "Manutenção e Suporte em Informática" },
  { codigo: 6076, nome: "Programação de Jogos Digitais" },
  { codigo: 6077, nome: "Redes de Computadores" },
  { codigo: 6080, nome: "Telecomunicações" },
  { codigo: 6999, nome: "Outros - Eixo Informação e Comunicação" },
  { codigo: 7081, nome: "Aeroportuário" },
  { codigo: 7082, nome: "Agrimensura" },
  { codigo: 7083, nome: "Carpintaria" },
  { codigo: 7084, nome: "Desenho de Construção Civil" },
  { codigo: 7085, nome: "Edificações" },
  { codigo: 7086, nome: "Estradas" },
  { codigo: 7087, nome: "Geodésia e Cartografia" },
  { codigo: 7088, nome: "Geoprocessamento" },
  { codigo: 7089, nome: "Hidrologia" },
  { codigo: 7091, nome: "Portos" },
  { codigo: 7092, nome: "Saneamento" },
  { codigo: 7093, nome: "Trânsito" },
  { codigo: 7094, nome: "Transporte Aquaviário" },
  { codigo: 7095, nome: "Transporte de Cargas" },
  { codigo: 7097, nome: "Transporte Metroferroviário" },
  { codigo: 7098, nome: "Transporte Rodoviário" },
  { codigo: 7999, nome: "Outros - Eixo Infra-Estrutura" },
  { codigo: 8133, nome: "Bombeiro Aeronáutico" },
  { codigo: 8099, nome: "Comunicações Aeronáuticas" },
  { codigo: 8126, nome: "Comunicações Navais" },
  { codigo: 8100, nome: "Controle de Tráfego Aéreo" },
  { codigo: 8101, nome: "Desenho Militar" },
  { codigo: 8102, nome: "Eletricidade e Instrumentos Aeronáuticos" },
  { codigo: 8103, nome: "Equipamentos de Voo" },
  { codigo: 8104, nome: "Estrutura e Pintura de Aeronaves" },
  { codigo: 8105, nome: "Fotointeligência" },
  { codigo: 8106, nome: "Guarda e Segurança" },
  { codigo: 8107, nome: "Hidrografia" },
  { codigo: 8108, nome: "Informações Aeronáuticas" },
  { codigo: 8109, nome: "Manobras e Equipamentos de Convés" },
  { codigo: 8110, nome: "Material Bélico" },
  { codigo: 8130, nome: "Mecânica de Aeronaves" },
  { codigo: 8111, nome: "Mergulho" },
  { codigo: 8112, nome: "Operação de Radar" },
  { codigo: 8113, nome: "Operação de Sonar" },
  { codigo: 8114, nome: "Operações de Engenharia Militar" },
  { codigo: 8115, nome: "Preparação Física e Desportiva Militar" },
  { codigo: 8116, nome: "Sensores de Aviação" },
  { codigo: 8117, nome: "Sinais Navais" },
  { codigo: 8118, nome: "Sinalização Náutica" },
  { codigo: 8119, nome: "Suprimento" },
  { codigo: 8999, nome: "Outros - Eixo Militar" },
  { codigo: 9120, nome: "Alimentos" },
  { codigo: 9121, nome: "Agroindústria" },
  { codigo: 9123, nome: "Cervejaria" },
  { codigo: 9124, nome: "Confeitaria" },
  { codigo: 9125, nome: "Panificação" },
  { codigo: 9127, nome: "Viticultura e Enologia" },
  { codigo: 9999, nome: "Outros - Eixo Produção Alimentícia" },
  { codigo: 10128, nome: "Artes Circenses" },
  { codigo: 10129, nome: "Teatro" },
  { codigo: 10130, nome: "Artes Visuais" },
  { codigo: 10131, nome: "Artesanato" },
  { codigo: 10132, nome: "Canto" },
  { codigo: 10154, nome: "Cenografia" },
  { codigo: 10133, nome: "Composição e Arranjo" },
  { codigo: 10134, nome: "Design Gráfico" },
  { codigo: 10135, nome: "Conservação e Restauro" },
  { codigo: 10136, nome: "Dança" },
  { codigo: 10137, nome: "Design de Calçados" },
  { codigo: 10138, nome: "Design de Embalagens" },
  { codigo: 10139, nome: "Design de Interiores" },
  { codigo: 10140, nome: "Design de Jóias" },
  { codigo: 10141, nome: "Design de Móveis" },
  { codigo: 10143, nome: "Fabricação de Instrumentos Musicais" },
  { codigo: 10157, nome: "Figurino Cênico" },
  { codigo: 10144, nome: "Instrumento Musical (nome do instrumento)" },
  { codigo: 10145, nome: "Modelagem do Vestuário" },
  { codigo: 10146, nome: "Multimídia" },
  { codigo: 10155, nome: "Museologia" },
  { codigo: 10147, nome: "Paisagismo" },
  { codigo: 10148, nome: "Processos Fotográficos" },
  { codigo: 10149, nome: "Produção de Áudio e Vídeo" },
  { codigo: 10150, nome: "Produção de Moda" },
  { codigo: 10151, nome: "Publicidade" },
  { codigo: 10152, nome: "Rádio e Televisão" },
  { codigo: 10153, nome: "Regência" },
  { codigo: 10158, nome: "Design de Moda" },
  { codigo: 10159, nome: "Estilismo e Coordenação de Moda" },
  { codigo: 10160, nome: "Produção Cultural" },
  { codigo: 10999, nome: "Outros - Eixo Produção Cultural e Design" },
  { codigo: 11154, nome: "Açúcar e Álcool" },
  { codigo: 11155, nome: "Biocombustíveis" },
  { codigo: 11173, nome: "Biotecnologia" },
  { codigo: 11156, nome: "Calçados" },
  { codigo: 11157, nome: "Celulose e Papel" },
  { codigo: 11158, nome: "Cerâmica" },
  { codigo: 11159, nome: "Construção Naval" },
  { codigo: 11160, nome: "Curtimento" },
  { codigo: 11164, nome: "Joalheria" },
  { codigo: 11165, nome: "Móveis" },
  { codigo: 11166, nome: "Petróleo e Gás" },
  { codigo: 11174, nome: "Petroquímica" },
  { codigo: 11167, nome: "Plásticos" },
  { codigo: 11171, nome: "Processos Gráficos" },
  { codigo: 11175, nome: "Química" },
  { codigo: 11169, nome: "Têxtil" },
  { codigo: 11170, nome: "Vestuário" },
  { codigo: 11176, nome: "Planejamento e Controle da Produção" },
  { codigo: 11177, nome: "Vidros" },
  { codigo: 11178, nome: "Processamento da Madeira" },
  { codigo: 11999, nome: "Outros - Eixo Produção Industrial" },
  { codigo: 12171, nome: "Agricultura" },
  { codigo: 12172, nome: "Agroecologia" },
  { codigo: 12173, nome: "Agronegócio" },
  { codigo: 12174, nome: "Agropecuária" },
  { codigo: 12175, nome: "Aquicultura" },
  { codigo: 12176, nome: "Cafeicultura" },
  { codigo: 12178, nome: "Florestas" },
  { codigo: 12179, nome: "Fruticultura" },
  { codigo: 12180, nome: "Geologia" },
  { codigo: 12181, nome: "Mineração" },
  { codigo: 12182, nome: "Pesca" },
  { codigo: 12184, nome: "Recursos Pesqueiros" },
  { codigo: 12185, nome: "Zootecnia" },
  { codigo: 12188, nome: "Apicultura" },
  { codigo: 12999, nome: "Outros - Eixo Recursos Naturais" },
  { codigo: 13181, nome: "Defesa Civil" },
  { codigo: 13182, nome: "Segurança do Trabalho" },
  { codigo: 13183, nome: "Prevenção e Combate a Incêndios" },
  { codigo: 13999, nome: "Outros - Eixo Segurança" },
];

export default cursos;
